// extracted by mini-css-extract-plugin
module.exports = {"detailsItem":"PositionDetailsList_detailsItem__3jA-7","detailsItemText":"PositionDetailsList_detailsItemText__3huRA"};